import { writable } from 'svelte/store';
import type { BtHomeRemoteIconStore } from 'src/types/BtHomeRemoteIcon';

/**
 * Remotes status-icon hint from the Remote Controls settings UI (RPC).
 * Entries are only `true` (can reveal the icon, never hide it). Missing → detection.
 */
const createBtHomeRemoteIconStore = () => {
	const { subscribe, update } = writable<BtHomeRemoteIconStore>({});

	return {
		subscribe,
		setRemotesPaired: (id: string) => update((state) => ({ ...state, [id]: true })),
		clearRemotes: (id: string) =>
			update((state) => {
				if (!(id in state)) {
					return state;
				}

				const next = { ...state };
				delete next[id];
				return next;
			}),
	};
};

export const btHomeRemoteIcon = createBtHomeRemoteIconStore();
